/** Raised during bootstrap when Microsoft sign-in did not start. */
export class EntraStartupError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'EntraStartupError';
  }
}

/** Replaces the page with a plain message; used before or instead of Angular, so it needs no framework. */
export function showStartupError(message: string): void {
  const host = document.querySelector('app-root') ?? document.body;
  const paragraph = document.createElement('p');
  paragraph.setAttribute('role', 'alert');
  paragraph.style.margin = '2rem';
  paragraph.style.fontFamily = 'sans-serif';
  paragraph.textContent = message;
  host.replaceChildren(paragraph);
}
